import { 
  collection, 
  setDoc, 
  doc, 
  addDoc, 
  getDocs, 
  query, 
  where, 
  serverTimestamp 
} from "firebase/firestore";
import { db, auth } from "config/firebase";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { toast } from "react-toastify";

export const seedVillageData = async () => {
  const villageSlug = "glg-panah";
  
  try {
    // 1. Check if village already exists
    const q = query(collection(db, "villages"), where("slug", "==", villageSlug));
    const snapshot = await getDocs(q);
    
    let villageId;
    
    if (snapshot.empty) {
      // Create New Village
      const villageRef = await addDoc(collection(db, "villages"), {
        name: "Geulanggang Teungoh",
        slug: villageSlug,
        address: "Kec. Kota Juang, Kab. Bireuen, Aceh",
        createdAt: serverTimestamp()
      });
      villageId = villageRef.id;
      console.log("Village created with ID:", villageId);
    } else {
      villageId = snapshot.docs[0].id;
      console.log("Village exists with ID:", villageId);
    }

    const villagePath = `villages/${villageId}`;

    // 2. Seed Profile documents
    const profiles = {
      general: {
        name: "Gampong Geulanggang Teungoh",
        phone: "0812-3456-7890",
        email: "geulanggang.teungoh@mail.com",
        about: "Gampong Geulanggang Teungoh merupakan salah satu gampong yang berada di Kecamatan Kota Juang, Kabupaten Bireuen.",
        vision: "Mewujudkan Gampong Geulanggang Teungoh yang Mandiri dan Religius.",
        misi: [
          "Meningkatkan kualitas SDM Gampong",
          "Meningkatkan pembangunan infrastruktur yang merata",
          "Mewujudkan tata kelola pemerintahan gampong yang transparan"
        ]
      },
      sejarah: {
        konten: "Menurut riwayat, Gampong Geulanggang Teungoh sudah ada sejak zaman kolonial Belanda...",
      },
      visimisi: {
        visi: "Mewujudkan Gampong Geulanggang Teungoh yang Mandiri, Sejahtera, dan Berakhlak Mulia",
        misi: [
          "Mengoptimalkan pelayanan publik kepada masyarakat",
          "Mengembangkan potensi ekonomi lokal gampong",
          "Memperkuat nilai-nilai agama dalam kehidupan bermasyarakat"
        ]
      },
      government: {
        structure_image: "https://via.placeholder.com/800x600?text=Struktur+Organisasi",
        total_staff: 12
      },
      sdm: {
        total_penduduk: 1540,
        laki_laki: 750,
        perempuan: 790,
        kepala_keluarga: 380
      },
      sdg: {
        achievements: ["Tanpa Kemiskinan", "Pendidikan Berkualitas", "Kesetaraan Gender"]
      }
    };

    for (const [docName, data] of Object.entries(profiles)) {
      await setDoc(doc(db, `${villagePath}/profile`, docName), data);
      console.log(`Profile ${docName} seeded.`);
    }

    // 3. Seed Sample News
    const newsBatch = [
      {
        title: "Pembangunan Jalan Desa Selesai",
        date: "2024-03-01",
        content: "Pembangunan jalan di dusun Mawar telah selesai 100%...",
        author: "Admin Gampong",
        imageUrl: "https://via.placeholder.com/400x300?text=Berita+1"
      },
      {
        title: "Kegiatan Posyandu Rutin",
        date: "2024-03-05",
        content: "Warga sangat antusias mengikuti kegiatan posyandu hari ini...",
        author: "Bidan Desa",
        imageUrl: "https://via.placeholder.com/400x300?text=Berita+2"
      }
    ];

    for (const item of newsBatch) {
      await addDoc(collection(db, `${villagePath}/news`), {
        ...item,
        createdAt: serverTimestamp()
      });
    }
    console.log("Sample news seeded.");

    // 5. Seed Default Users / Roles & Firebase Auth
    const defaultUsers = [
      { email: "superadmin@gampong.id", password: "123456", role: "superadmin" },
      { email: "admin@gampong.id", password: "123456", role: "author" }
    ];

    for (const user of defaultUsers) {
      // Create Firestore Role Record
      await setDoc(doc(db, "users", user.email), {
        email: user.email,
        role: user.role,
        createdAt: serverTimestamp()
      });

      // Attempt to create Firebase Auth account
      try {
        await createUserWithEmailAndPassword(auth, user.email, user.password);
        console.log(`Auth account created for ${user.email}`);
      } catch (authError) {
        if (authError.code === "auth/email-already-in-use") {
          console.log(`Auth account for ${user.email} already exists.`);
        } else {
          console.error(`Error creating auth for ${user.email}:`, authError);
        }
      }
    }
    console.log("Default user roles & auth accounts seeded.");

    toast.success("Firebase initialized successfully! All base documents, user roles, and auth accounts (password: 123456) have been created.");
  } catch (error) {
    console.error("Seeding error:", error);
    toast.error("Error seeding data: " + error.message);
  }
};
